import React, { useState, useEffect } from "react"; import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { APIURL,TZ } from "../../Global";
import axios from 'axios';
import "./config.css"
function VerifyOTP(props) {
    const [otp, setOtp] = useState("")
    const [error, setError] = useState(false)
    const [method, setMethod] = useState("")
    const [login_datas, setLogin_datas] = useState(
        JSON.parse(sessionStorage.getItem("logindatas"))
            ? JSON.parse(sessionStorage.getItem("logindatas"))
            : null
    );
    const handleotp = (e) => {

        const val = e.target.value;
        const key = e.target.name;

        setOtp(val)
    };
    const handleChange = (e) => {
        e.preventDefault();
        const val = e.target.value;

        setMethod(val)



        /*Handle SENDOTP */


        let data = {};
        if (e.target.value === "Email ID") {
            data = {
                email: login_datas.email,
              

            };
        } else {
            data = {
                code: login_datas.country_code,
                mobile_number: login_datas.mobile_number,
               
            };
        }

        axios
            .post(
                `${APIURL}/api/v1/account/send-otp/`,

                data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                if (res.data.status === "success") {

                } else {


                }
            })
            .catch((err) => { });

    };
    const submitOTP = () => {

        let data = {}
        if (method === "Email ID") {
            data = {
                email: login_datas.email,
                otp: otp,
                requested_user:login_datas.user_type,
            };
        } else {
            data = {
                code: login_datas.country_code,
                mobile_number: login_datas.mobile_number,
                otp: otp,
                requested_user:login_datas.user_type,
            };
        }
        axios
            .post(
                `${APIURL}/api/v1/account/verify-otp/`,
                data,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then((res) => {
                if (res.data.status === "success") {
                    props.onSuccess();
                    sessionStorage.setItem("verified_login", true);
                }
                else {

                    setError(true);
                    
                }

            })

    };



    return (
        <div style={{backgroundColor:"aliceblue"}} ><br/>
            <h6 className="title_config">Verify OTP </h6>
            <div style={{ justifyContent: "center" }}>
                <span style={{ marginLeft: "30%" }} className="text-style-here">Where do you want to receive the OTP{"  "}  </span>
                <select
                    className="boxpwdverify"
                    value={method}
                    onChange={handleChange}>
                    <option value="" selected hidden  >*Select</option>
                    <option value="Email ID" >Email</option>
                    <option value="Phone Number">Phone</option>
                </select>
                {method !== "" ? <small style={{ marginLeft: "32%" }}>OTP has been shared to your registered {method}</small> : ""}
            </div><br />

            <div className="" style={{ justifyContent: "center" ,textAlign:"center" }} >
                <input value={otp} name="otp" type="text" className="boxpwd " onChange={handleotp}></input>
                {error? (
                                        <div
                                            style={{ zIndex: "auto", width:"237px" }}
                                            className="error-validation-msg"
                                        >
                                          Invalid OTP
                                        </div>
                                    ) : null}
            </div>
            <br />
            <div className="" style={{ display: "flex", justifyContent: "center" }}>

                <button onClick={() => submitOTP()} className="save">SUBMIT </button>
                <span>&nbsp;&nbsp;&nbsp;</span>
                <button onClick={() => props.onCancel()} className="edit">CANCEL</button>

            </div><br /><br />

        </div>)
}
export default VerifyOTP;